import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';
import RowIsMore from '@components/RowIsMore';
import JustificationModal from '@components/JustificationModal';

import { getTypeUsers, updateRestringir } from '@actions/typeUsers'
import { sendActionToBitacora  } from '@actions/bitacora';

import { getValueLanguageObj } from '@utils/general'
// import './style.scss'

import {
  StatusVisible,
  StatusRestringido
} from '@constants/general'

class TypeUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: true,
      typeUsers: [],
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
    };
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    const { getTypeUsers } = this.props
    this.setState({ loadingTable: true });
    const response = await getTypeUsers();
    if (!response?.status) {
      return this.setState({
        typeUsers: response.data,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  }

  onConfirmRestringido = (node) => {
    const { t } = this.props;
    const txtHelper = node.restringido === StatusRestringido.IS_RESTRINGIDO ? t('No restringir') : t('Restringir')
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea cambiar la restricción a {{ELEMENTO}} ?', { ELEMENTO: txtHelper}),
        continueAction: ({justification}) => this.confirmRestringido(node, justification)
      },
    });
  }

  confirmRestringido = async (data, justification) => {
    const { t, updateRestringir, sendActionToBitacora } = this.props;
    this.setState({loadingTable: true})
    const response = await updateRestringir({...data});
    if (!response?.status) {

      const dataBitacora = {
        transactionName: data.restringido === StatusRestringido.IS_RESTRINGIDO ? 'actNoRestringir' : 'actRestringir',
        reason: `${data.tipo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000
      });
      
      if (data.restringido === StatusRestringido.NOT_RESTRINGIDO ) {
        return setTimeout(() => {
          this.props.history.push( {pathname: "/type-users/allowed-sections", state: { id: data.id, ...data }})
        }, 500);
      }

      this.loadData();
    }
    this.setState({loadingTable: false})
  }


  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };


  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  columnAsunto = (rowData, detail) => {
    const getAsunto = getValueLanguageObj(JSON.parse(rowData.asunto))
    return (
    <>
        <span className="p-column-title">{detail.header}</span>
        <RowIsMore
        text={getAsunto}
      />
    </>
  )}

  columnDescription = (rowData, detail) => (
      <>
        <span className="p-column-title">{detail.header}</span>
        <RowIsMore
          text={rowData.descripcion}
        />
      </>
      )

  templateEstatus = (node, detail) => {
    const { t } = this.props
    if (node.activo) {
      return (
        <div className="p-text-center-lg">
          <span className="p-column-title">{detail.header}</span>
          <i className="pi pi-check" />
        </div>
      );
    }
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className={`badge-red cursor-not-pointer`} aria-hidden="true" > {t('OCULTA')} </span>
        </>
      );
  }

  templateVisible = (node, detail) => {
    const { t } = this.props;
    if (node.visible === StatusVisible.IS_VISIBLE) {
      return (
        <div className="p-text-center-lg">
          <span className="p-column-title">{detail.header}</span>
          <Button
            type="button"
            icon="pi pi-check"
            className="p-button-text"
            style={{ marginRight: '.5em' }}
            onClick={() => {}}
          />
        </div>
      );
    }

    if (node.visible === StatusVisible.IS_HIDDEN) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-red" aria-hidden="true" onClick={ () => {}}> {t('OCULTA')} </span>
        </>
      );
    }

    return (<span className="p-column-title">{detail.header}</span>);
  };

  templateEdit = (node, detail) => {

    if (node.restringido === StatusRestringido.IS_RESTRINGIDO){
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <Button
            type="button"
            icon="pi pi-pencil"
            className="p-button-text"
            tooltip='Editar secciones permitidas'
            style={{ marginRight: '.5em' }}
            onClick={() => this.props.history.push( {pathname: "/type-users/allowed-sections", state: { id: node.id, ...node }})}
          />
        </div>
      )
    }
    return (
      <div>
        <span className="p-column-title">{detail.header}</span>
        <span></span>
      </div>
    )

  }

  templateRestringido = (node, detail) => {
    const { t } = this.props;
    if (node.restringido === StatusRestringido.IS_RESTRINGIDO) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className={`badge-blue cursor-pointer`} aria-hidden="true" onClick={ () => this.onConfirmRestringido(node)}> {t('Es restringido')} </span>
        </>
      );
    }

    if (node.restringido === StatusRestringido.NOT_RESTRINGIDO) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className={`badge-green cursor-pointer`} aria-hidden="true" onClick={ () => this.onConfirmRestringido(node)}> {t('No tiene restricción')} </span>
        </>
      );
    }

    return (<span className="p-column-title">{detail.header}</span>);
  };

  render() {
    const { history, t, isFullAdmin } = this.props;
    const { loadingTable, typeUsers, showModalJustification } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
      </>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Tipos de usuarios')} rightComponent={rightHeader} />
          <div className="card p-grid">
            <p>{t('Listado de los tipos de usuarios que se tiene el portal')}</p>
            <div className="p-col-12 p-mt-2">
              <DataTable
                value={typeUsers}
                lazy
                loading={loadingTable}
                className="table-languages"
                // paginator={!!emails}
                // rows={lazyParams.rows}
                // totalRecords={emailsTotal}
                // first={lazyParams.first}
                // onPage={this.onPage}
              >
                <Column
                  header={t('Id')}
                  field="id"
                  body={this.columnResponsive}
                  className="column-action p-mr-4"
                />
                <Column
                  header={t('Tipo')}
                  field="tipo"
                  body={this.columnResponsive}
                />
                <Column
                  header={t('Clave')}
                  field="clave"
                  body={this.columnResponsive}
                  // className="column-max p-text-center-lg"
                />
                <Column
                  header={t('Visible')}
                  body={this.templateVisible}
                  className="p-text-center-lg"
                />
                <Column
                  header={t('Restringido')}
                  body={this.templateRestringido}
                  // className="column-action"
                />
                <Column
                  header={t('E. secciones')}
                  body={this.templateEdit}
                  className="p-text-center-lg"
                />
              </DataTable>
            </div>
          </div>
        </div>
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
        <Toast ref={(el) => (this.toast = el)} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isFullAdmin: state.settings.isFullAdmin,
});

const mapDispatchToProps = {
  getTypeUsers,
  updateRestringir,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(TypeUsers);
